import React from 'react';
import { createFileRoute } from '@tanstack/react-router'
import { Box, Typography, Paper } from '@mui/material';
import { MoonPhaseDiagram } from '../components/menu/MoonWithPopup';
import LunarHelixCalendar from '../components/effects/LunarHelixCalendar';
import NavBar from '../components/menu/NavBar';
import { usePastFloodEvents } from '../layers/past_flood_events';
import Moon from '../components/menu/Moon';

export const Route = createFileRoute('/moon')({
  component: RouteComponent,
})

function RouteComponent() {
  const [initialDate] = React.useState<Date>(() => new Date());
  const [currentDate, setCurrentDate] = React.useState<Date>(initialDate);
  return (
    <>
    <Box
      sx={{
        // minHeight: '100dvh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // height: '100dvh',
        p: { xs: 2, md: 4 },
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          position: { md: 'sticky' } as any,
          top: { md: 20 },
          p: 3,
          borderRadius: 3,
          background: 'background.paper',
          borderColor: 'divider',
          display: 'flex',
          // flexDirection: 'column',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
        }}
      >
        <Box>
          <Moon currentTime={currentDate} size={240} />
        </Box>
        <MoonPhaseDiagram currentTime={currentDate} R={180} />
        {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" width="400" height="400" role="img"
  aria-label="Moon phase cycle ring: New at top, First Quarter at right, Full at bottom, Last Quarter at left, clockwise.">
  <defs>
    <radialGradient id="space" cx="35%" cy="30%" r="80%">
      <stop offset="0%" stop-color="#111a33"/>
      <stop offset="55%" stop-color="#070a16"/>
      <stop offset="100%" stop-color="#03040a"/>
    </radialGradient>

    <radialGradient id="ringDepth" cx="35%" cy="30%" r="80%">
      <stop offset="0%" stop-color="#ffffff" stop-opacity="0.18"/>
      <stop offset="55%" stop-color="#ffffff" stop-opacity="0.06"/>
      <stop offset="100%" stop-color="#000000" stop-opacity="0.35"/>
    </radialGradient>

    <filter id="softGlow" x="-30%" y="-30%" width="160%" height="160%">
      <feGaussianBlur stdDeviation="2.2" result="b"/>
      <feColorMatrix in="b" type="matrix"
        values="1 0 0 0 0
                0 1 0 0 0
                0 0 1 0 0
                0 0 0 0.65 0" result="g"/>
      <feMerge>
        <feMergeNode in="g"/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>

    <linearGradient id="g0" gradientUnits="userSpaceOnUse" x1="200.000" y1="40.000" x2="313.137" y2="86.863">
      <stop offset="0%" stop-color="#0b1020"/><stop offset="100%" stop-color="#2d313d"/>
    </linearGradient>
    <linearGradient id="g1" gradientUnits="userSpaceOnUse" x1="313.137" y1="86.863" x2="360.000" y2="200.000">
      <stop offset="0%" stop-color="#2d313d"/><stop offset="100%" stop-color="#808284"/>
    </linearGradient>
    <linearGradient id="g2" gradientUnits="userSpaceOnUse" x1="360.000" y1="200.000" x2="313.137" y2="313.137">
      <stop offset="0%" stop-color="#808284"/><stop offset="100%" stop-color="#d4d2cb"/>
    </linearGradient>
    <linearGradient id="g3" gradientUnits="userSpaceOnUse" x1="313.137" y1="313.137" x2="200.000" y2="360.000">
      <stop offset="0%" stop-color="#d4d2cb"/><stop offset="100%" stop-color="#f6f3e8"/>
    </linearGradient>
    <linearGradient id="g4" gradientUnits="userSpaceOnUse" x1="200.000" y1="360.000" x2="86.863" y2="313.137">
      <stop offset="0%" stop-color="#f6f3e8"/><stop offset="100%" stop-color="#d4d2cb"/>
    </linearGradient>
    <linearGradient id="g5" gradientUnits="userSpaceOnUse" x1="86.863" y1="313.137" x2="40.000" y2="200.000">
      <stop offset="0%" stop-color="#d4d2cb"/><stop offset="100%" stop-color="#818284"/>
    </linearGradient>
    <linearGradient id="g6" gradientUnits="userSpaceOnUse" x1="40.000" y1="200.000" x2="86.863" y2="86.863">
      <stop offset="0%" stop-color="#818284"/><stop offset="100%" stop-color="#2d313d"/>
    </linearGradient>
    <linearGradient id="g7" gradientUnits="userSpaceOnUse" x1="86.863" y1="86.863" x2="200.000" y2="40.000">
      <stop offset="0%" stop-color="#2d313d"/><stop offset="100%" stop-color="#0b1020"/>
    </linearGradient>
  </defs>

  <circle cx="200" cy="200" r="198" fill="url(#space)"/>

  <g filter="url(#softGlow)">
    <path d="M 200.000 40.000 A 160 160 0 0 1 313.137 86.863" stroke="url(#g0)" stroke-width="44" fill="none"/>
    <path d="M 313.137 86.863 A 160 160 0 0 1 360.000 200.000" stroke="url(#g1)" stroke-width="44" fill="none"/>
    <path d="M 360.000 200.000 A 160 160 0 0 1 313.137 313.137" stroke="url(#g2)" stroke-width="44" fill="none"/>
    <path d="M 313.137 313.137 A 160 160 0 0 1 200.000 360.000" stroke="url(#g3)" stroke-width="44" fill="none"/>
    <path d="M 200.000 360.000 A 160 160 0 0 1 86.863 313.137"  stroke="url(#g4)" stroke-width="44" fill="none"/>
    <path d="M 86.863 313.137 A 160 160 0 0 1 40.000 200.000"   stroke="url(#g5)" stroke-width="44" fill="none"/>
    <path d="M 40.000 200.000 A 160 160 0 0 1 86.863 86.863"    stroke="url(#g6)" stroke-width="44" fill="none"/>
    <path d="M 86.863 86.863 A 160 160 0 0 1 200.000 40.000"    stroke="url(#g7)" stroke-width="44" fill="none"/>

    <circle cx="200" cy="200" r="160" fill="none" stroke="url(#ringDepth)" stroke-width="44"/>
  </g>

  <g font-family="ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial" font-size="14"
     fill="#d7dbea" opacity="0.9" letter-spacing="0.3">
    <text x="200" y="24" text-anchor="middle">NEW</text>
    <text x="376" y="206" text-anchor="end">FIRST Q</text>
    <text x="200" y="392" text-anchor="middle">FULL</text>
    <text x="24" y="206" text-anchor="start">LAST Q</text>
  </g>
</svg> */}
      </Paper>
    </Box>
    </>
  );
}
